<template>
  <div>
    <!-- ACCOUNT PROFILE -->
    <b-container v-if="profile">
      <b-row>
        <b-col cols="4" md="3" class="p-0 pt-md-4 pr-md-5 mb-3">
          <div
            class="p-1 border border-1 rounded-circle"
            :style="
              `border-color:` +
              profile.influencer.avatar_border_hex +
              ` !important`
            "
          >
            <div
              class="rounded-circle"
              :style="
                `padding: 49%; background:  url(` +
                profile.influencer.profile_photo_url +
                `) center/cover;`
              "
            />
          </div>
        </b-col>

        <b-col cols>
          <b-row class="mb-4">
            <b-col>
              <h1 class="font-weight-bold overflow-hidden">
                <span
                  v-if="profile.influencer.full_name"
                  v-text="profile.influencer.full_name"
                />
                <span v-else v-text="`@` + profile.influencer.username" />
              </h1>
              <small
                class="font-weight-bold align-middle"
                v-if="profile.influencer.rate_label"
              >
                <b-img
                  v-if="rateIconUrl"
                  class="mb-1 mr-1"
                  :src="rateIconUrl"
                />
                {{ profile.influencer.rate_label }}
              </small>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col cols="3" md="2">
              <h5 class="m-0">{{ profile.influencer.followers_count }}</h5>
              <small class="grey-light">Followers</small>
            </b-col>
            <b-col cols="4" md="3" lg="2" class="pl-md-0">
              <h5 class="m-0">{{ profile.influencer.public_post_count }}</h5>
              <small class="grey-light">Public Posts</small>
            </b-col>
            <b-col cols="3" md="2" class="p-0">
              <h5 class="m-0">{{ profile.influencer.vip_post_count }}</h5>
              <small class="grey-light">VIP Posts</small>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col>
              <div
                class="grey-light pre-formatted"
                v-html="profile.influencer.biography"
                v-linkified
              ></div>
            </b-col>
          </b-row>

          <b-row class="p-0" v-if="influencer_uid !== user.influencer_uid">
            <b-col cols="6" md="5" lg="3" v-if="isVelloPackEnabled">
              <add-vellos-button :action="`new`" />
            </b-col>

            <b-col cols="6" md="5" lg="3" v-if="isVipPackEnabled">
              <vip-access-button class="ml-2" />
            </b-col>

            <b-col
              cols="12"
              xl="6"
              class="p-0"
              v-if="isInfluencerWithExtraPackage"
            >
              <extra-package-button />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- ALL POSTS -->
    <list-feeds v-if="profile" :influencer="profile.influencer" />

    <!-- NOT FOUND -->
    <div class="vh-100" v-else-if="!loading">
      <h4 class="text-center mt-5 pt-5">Influencer not found</h4>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ExtraPackageButton from '../../components/ExtraPackageButton'
import AddVellosButton from '../../components/AddVellosButton'
import VipAccessButton from '../../components/VipAccessButton'
import ListFeeds from '../../components/ListFeeds'

export default {
  name: 'InfluencerProfile',
  components: {
    ExtraPackageButton,
    AddVellosButton,
    VipAccessButton,
    ListFeeds,
  },

  data() {
    return {
      influencer_uid: null,
      extra_uid: null,
      loading: true,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      card: (state) => state.auth.card,
      profile: (state) => state.influencer.profile,
    }),

    isVipPackEnabled() {
      return this.profile.influencer.vip_post_count > 0
    },

    rateIconUrl() {
      if (this.profile) {
        let score = this.profile.influencer.rate_score

        if (score > 4 && score <= 5) {
          return require('@/assets/img/rate-5.svg')
        }
        if (score > 3 && score <= 4) {
          return require('@/assets/img/rate-4.svg')
        }
        if (score > 2 && score <= 3) {
          return require('@/assets/img/rate-3.svg')
        }
        if (score > 1 && score <= 2) {
          return require('@/assets/img/rate-2.svg')
        }

        return require('@/assets/img/rate-1.svg')
      }

      return null
    },

    isInfluencerWithExtraPackage() {
      return this.influencer_uid === this.extra_uid
    },

    isVelloPackEnabled() {
      return (
        this.profile.influencer.package_settings.is_augmented_pack_enabled ||
        (this.profile.influencer.package_settings.is_single_pack_enabled &&
          !this.profile.influencer.show_waitlist_to_purchase_pack)
      )
    },
  },

  methods: {
    ...mapActions({
      getUserCard: 'auth/getUserCard',
      getProfile: 'influencer/getProfile',
    }),
    ...mapMutations({
      clearProfile: 'influencer/clearProfile',
    }),
  },

  async created() {
    let vm = this
    vm.loading = true
    vm.influencer_uid = vm.$route.params.id

    if (!vm.influencer_uid) {
      vm.$router.replace({ name: 'influencer.following-page' })
    }

    await vm.getProfile(vm.influencer_uid)
    vm.loading = false

    if (!this.card) {
      await this.getUserCard()
    }

    this.extra_uid = process.env.VUE_APP_EXTRA_UID
  },

  async destroyed() {
    await this.clearProfile()
  },
}
</script>

<style scoped></style>
